const { cartUpdate } = window.BAO.Utils

class BaoBundleRemoveBrokenLines extends window.BAO.CustomElement() {
  #searchParamKey = 'remove_broken_bundle'

  connectedCallback () {
    super.connectedCallback()

    if (!new URL(window.location.href).searchParams.has(this.#searchParamKey)) return

    this.removeLines(JSON.parse(this.dataset.lineKeys || '[]')).finally(() => {
      // Read the address again: the bundle picker may have changed it meanwhile.
      const url = new URL(window.location.href)
      url.searchParams.delete(this.#searchParamKey)
      window.history.replaceState(window.history.state, '', url)
    })
  }

  /**
   * Removes the broken bundle lines by their keys in one request, then redraws
   * the cart drawer and cart count without opening the drawer. A failure is
   * logged and the page carries on.
   * @param {string[]} lineKeys
   */
  async removeLines (lineKeys) {
    if (lineKeys.length === 0) return

    const cartItems = document.querySelector('cart-drawer-items')
    const sections = cartItems?.getSectionsToRender().map((section) => section.section)

    try {
      const state = await cartUpdate({
        updates: Object.fromEntries(lineKeys.map((key) => [key, 0])),
        sections,
        sections_url: window.location.pathname,
      })

      if (!state.sections || !cartItems) return

      document.querySelector('cart-drawer')?.classList.toggle('is-empty', state.item_count === 0)
      cartItems.renderSectionFromState(state)
    } catch (error) {
      console.error(error)
    }
  }
}

if (!window.customElements.get('bao-app-bundle-remove-broken-lines')) {
  window.customElements.define('bao-app-bundle-remove-broken-lines', BaoBundleRemoveBrokenLines)
}
